module.exports = __webpack_public_path__ + "14bd7782f87ea22917492705c8fbe136.svg";